<template>
<div class="cart-container" :class="[expanded != true ? 'unexpanded' : '', selectedProducts.length > 0 ? 'hasProduct' : '']">
    <div @click="() => {expanded = !expanded}" class="expand-arrow">
        <span>></span>
    </div>
    <div v-on:click.stop class="unexpanded-cart" v-if="expanded == true">
        <div v-if="!redeem_without_full_capacity" class="price-container">
            <span class="title">{{capacity}}%</span>
            <span class="price">Full</span>
        </div>
        <p v-if="canCheckout" class="products-container-title">You are good to go</p>
        <p v-else class="products-container-title">Add up to ({{ maxProductsToAdd }}) <br/> more gifts! <template v-if="redeem_without_full_capacity && minimumProductsToAdd > 0">Minimum gifts: {{ minimumProductsToAdd }}</template></p>
        <ul class="products-container no-scrollbar">
            <li v-for="addonProduct in selectedProducts" :key="addonProduct.variants[0].id">
                <div class="addon-container">
                    <img @click="removeProduct(addonProduct)" class="circle remove"  src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x">
                    <img @click="openProduct(addonProduct)" class="main-image" loading="lazy" :src="getProductImage(addonProduct)" >
                    <p class="circle qty">{{ addonProduct.qty }}</p>
                </div>
            </li>
            <li v-for="i in maxProductsToAdd" :key="'holder_'+i">
                <div class="addon-container placeholder">
                    <img class="main-image" loading="lazy" src="https://cdn.shopify.com/s/files/1/1363/8433/files/add_gift.svg?v=1714663304" >
                </div>
            </li>
        </ul>
        <button @click="checkout" class="happybox-button border" :class="[!canCheckout ? 'gray' : 'green',isLoading ? 'isLoading' : '']" :disabled="!canCheckout">{{ isLoading ? 'loading...' : 'Next Step' }}</button>
      </div>
</div>
</template>
<script>
export default {
    props:{
        capacity: Number,
        selectedProducts: Array,
        maxProductsToAdd: Number,
        isLoading: Boolean,
        isBundle: Boolean,
        tabs: Array,
        redeem_without_full_capacity: Boolean,
        minimumProductsToAdd: Number,
        canCheckout: Boolean
    },
    data(){
        return {
            expanded: true,
        }
    },
    computed:{
    },
    methods:{
        getProductImage(product){
            if(product.variants[0].featured_image){
                return product.variants[0].featured_image.src;
            }

            if(product.tags.includes("no_hover")){
                return product.images[0].src
            }

            return (product.images.length > 0) ? product.images[product.images.length - 1].src : '';
            
        },
        removeProduct(product){
            this.$emit("removeproduct",product);
        },
        checkout(){
            this.$emit("checkout");
        },
        openProduct(product){
            this.$emit("openmodal",product)
        }
    }
}
</script>
<style scoped>
.cart-container{
    width: 0%;
    height: 100%;
    display: none;
    transition: all 0.3s ease-in;
}

.cart-container.hasProduct{
    display: block;
    z-index: 4;
    background-color: white;
    height: 100vh;
    position: fixed;
    width: 10%;
    right: 0;
    top: 0;
}

.cart-container.hasProduct.unexpanded{
    right: -10%;
}

/* Unexpanded cart css */
.unexpanded-cart{
    width: 100%;
    height: 100%;
    box-shadow: 0px 10px 15px rgba(31, 41, 55, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.unexpanded-cart .happybox-button{
    width: 90%;
    padding: 5%;
}

.price-container{
    display: flex;
    flex-direction: column;
    text-align: center;
    box-shadow: inset 0px -1px 0px #E6E8EC;
    width: 100%;
    position: relative;
    padding: 5% 0%;
}

.price-container .title{
    font-weight: bold;
    font-size: 1.8vw;
    line-height: 1.2;
}

.price-container .price{
    font-size: 1.3vw;
    line-height: 1.2;
}

.expand-arrow{
    position: absolute;
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
    border-left: 1px solid #E5E7EB;
    border-top: 1px solid #E5E7EB;
    border-radius: 4px 0px 0px 4px;
    top: 2.65%;
    left: -25%;
    width: 25%;
    height: 3.5%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #374151;
    font-size: 2vw;
    cursor: pointer;
}

.unexpanded .expand-arrow span{
    transform: rotate(180deg);
}

.products-container-title{
    font-weight: bold;
    font-size: 0.9vw;
    line-height: 1.5;
    padding: 10% 5% 5%;
    text-align: center;
}

.unexpanded-cart .products-container{
    width: 90%;
    padding: 5%;
    display: flex;
    flex-direction: column;
    list-style: none;
    justify-content: flex-start;
    margin: unset;
    max-height: 80%;
    overflow: scroll;
}


.unexpanded-cart .products-container li{
    width: 100%;
    margin-bottom: 2vw;
}

.unexpanded-cart .addon-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
}

.unexpanded-cart .addon-container .main-image{
    width: 100%;
    background-color: #f6f6f6;
    border: unset;
    cursor: pointer;
}

.unexpanded-cart .addon-container.placeholder{
    background-color: #f6f6f6;
    padding: 35%;
}

.circle{
    position: absolute;
    font-size: 1vw;
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 50%;
    color: #0f0c38;
    background-color: white;
    border: 1px solid gray;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.remove{
    top: 0.1vw;
    right: 0.1vw;
    border: unset;
}

.remove span{
    margin-bottom: 10%;
}

.qty{
    bottom: 0.25vw;
    right: 0.25vw;
}

@media only screen and (max-device-width: 767px){
    .cart-container.hasProduct{
        position: fixed;
        bottom: 0;
        height: auto;
        background-color: white;
        box-shadow: 0px -1px 0px 1px #0000001f;
        top: unset;
        width: 100%;
    }

    .unexpanded-cart{
        height: 100%;
        position: relative;
        top: unset;
        padding: 3% 5%;
    }

    .products-container-title{
        display: none;
    }

    .price-container{
        flex-direction: row;
        position: absolute;
        top: -29.5%;
        left: 10%;
        width: auto;
        background-color: white;
        padding: 3%;
        gap: 5px;
        box-shadow: 0 -5px 5px 2px #0000002f;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    .price-container .title,.price-container .price{
        font-size: 4vw;
        font-weight: bold;
    }

    .expand-arrow{
        display: none;
    }

    .happybox-button{
        width: 100%;
        padding: 2%;
    }

    .unexpanded-cart .products-container{
        flex-direction: row;
        width: 100%;
        padding: 0 0 2%;
        gap: 10px;
        justify-content: center;
    }

    .unexpanded-cart .products-container li{
        width: 20%;
        margin: unset;
    }

    .circle{
        font-size: 3vw;
        width: 5vw;
        height: 5vw;
        
    }
    .remove{
        top: -1.5vw;
        left: -1.5vw;
    }
    .qty{
        bottom: -.5vw;
        right: -.5vw;
    }

    .unexpanded-cart .happybox-button{
        width: 100%;
        padding: 2% 10%;
    }
}

</style>